import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#014527", // vert
    },
    secondary: {
      main: "#035417", // Rouge vif
    },
    text: {
      primary: "#333", // Texte principal
      secondary: "#808080", // Texte clair
      input: "#000", // Texte pour les champs d'entrée
    },
    background: {
      default: "#f4f4f4", // Fond gris clair
      paper: "#ffffff", // Fond blanc
    },
  },
});

export default theme;
